/**
 * PilotHintButtonContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled pilot hint button container.
 */
const PilotHintButtonContainer = styled.div`
  position: relative;
  right: ${Screen.widthRatio * 122}px;
`;

export default PilotHintButtonContainer;
